import { ChangeDetectorRef, Component, ElementRef, Injectable, OnInit, ViewChild } from '@angular/core';
import { Product } from 'src/app/classes/product';
import * as fa from '@fortawesome/free-solid-svg-icons';
import { FormControl, FormGroup, FormRecord, Validators } from '@angular/forms';
import { Customer } from 'src/app/classes/customer';
import { NgbDateAdapter, NgbDateParserFormatter, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocationComponent } from '../order/schedule/location/location.component';
import { Organization } from 'src/app/classes/organization';
import { AuthService } from 'src/app/services/auth.service';
import { CustomerService } from 'src/app/services/customer.service';
import { SettingsService } from 'src/app/services/settings.service';
import { CustomerContact } from 'src/app/classes/customer-contact';
import { Holiday } from 'src/app/classes/holiday';
import { Capacitor } from '@capacitor/core';
import { EmployeeService } from 'src/app/services/employee.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Employee } from 'src/app/classes/employee';
import { environment } from 'src/environments/environment';
import { EmployeeAvailable } from 'src/app/classes/employee-available';
import { FeedbackComponent } from '../order/schedule/feedback/feedback.component';
import { LocationService } from 'src/app/services/location.service';
import locales from 'src/app/constants/locales';
import { LanguageSelectorComponent } from '../../common/language-selector/language-selector.component';
import { ApiService } from 'src/app/services/api.service';
import { City } from 'src/app/classes/city';
import { PrivacyPolicyComponent } from '../../common/privacy-policy/privacy-policy.component';
import { TncComponent } from '../../common/tnc/tnc.component';
import { Assignment } from 'src/app/classes/assignment';
import productUnits from 'src/app/constants/product-units';
import { Title } from '@angular/platform-browser';
import { LocaleSortPipe } from 'src/app/pipes/locale-sort.pipe';
import { ProductComponent } from '../order/services/product/product.component';

@Injectable()
export class CustomDateAdapter {
  fromModel(value: string): NgbDateStruct {
    if (!value)
      //@ts-ignore
      return null

    let parts = value.split('-');

    return { year: +parts[0], month: +parts[1], day: +parts[2] }
  }

  toModel(date: NgbDateStruct): string // from internal model -> your mode
  {
    //@ts-ignore
    return date ? date.year + "-" + ('0' + date.month).slice(-2)
      + "-" + ('0' + date.day).slice(-2) : null
  }
}

@Injectable()
export class CustomDateParserFormatter {
  parse(value: string): NgbDateStruct {
    if (!value)
      // @ts-ignore
      return null
    let parts = value.split('/');
    return { year: +parts[2], month: +parts[1], day: +parts[3] } as NgbDateStruct

  }
  format(date: NgbDateStruct): string {
    // @ts-ignore
    return date ? ('0' + date.day).slice(-2) + "/" + ('0' + date.month).slice(-2) + "/" + date.year : null
    //return date ? date.year + "/" + ('0' + date.month).slice(-2) + "/" + ('0' + date.day).slice(-2) : null
  }
}

@Component({
  selector: 'app-partner',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss'],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomDateAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    LocaleSortPipe
  ]
})
export class PartnersComponent implements OnInit {
  @ViewChild('productRequest') productRequest!: ElementRef

  defaultYoutubeLink = environment.default_youtube_link
  defaultYoutubeChannelLink = environment.default_youtube_channel_link
  defaultFacebookLink = environment.default_facebook_link
  defaultXLink = environment.default_x_link

  loading = false
  products: Product[] = []
  organization = new Organization()
  organizations: Organization[] = []
  selectedOrganization: any
  assignments!: Assignment[]
  currentUser = new CustomerContact()
  locationName = $localize`Set location`
  holidays: Holiday[] = []
  employee = new EmployeeAvailable()
  locale = $localize.locale
  locales = locales
  fa = fa
  environment = environment
  city!: City
  productUnits = productUnits
  selectedAssignment: Assignment | undefined
  copyrightYear = new Date().getFullYear()

  platform = ''
  isLoggedIn = false
  minimumOrder = 0
  minDate!: NgbDateStruct

  allProducts: Product[] = []
  orderProducts: any[] = []
  cartProducts: Product[] = []

  shiftForm = new FormGroup({
    date: new FormControl<null | string>(null, [Validators.required]),
    start_times: new FormControl<null | string[]>(null),
    assignment_id: new FormControl<null | number>(null, [Validators.required]),
    customer: new FormControl<null | Customer>(null, [Validators.required]),
    employee_id: new FormControl<null | number>(null),
    products: new FormControl<any>([]),
    notes: new FormControl('', { nonNullable: true }),
  })

  constructor(private modalService: NgbModal,
    private authService: AuthService,
    private customerService: CustomerService,
    private settingsService: SettingsService,
    private employeeService: EmployeeService,
    private route: ActivatedRoute,
    private locationService: LocationService,
    private apiService: ApiService,
    public router: Router,
    private cdRef: ChangeDetectorRef,
    private titleService: Title,
    private localeSortPipe: LocaleSortPipe
  ) { }


  ngOnInit() {
    this.platform = Capacitor.getPlatform()

    const now = new Date()
    this.minDate = { year: now.getUTCFullYear(), month: now.getMonth() + 1, day: now.getDate() }

    let order = JSON.parse(localStorage.getItem('order')!)

    if (!this.shiftForm.controls.date.value) {
      this.shiftForm.controls.date.setValue(new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0])
      this.shiftForm.controls.date.updateValueAndValidity()

      localStorage.setItem('order', JSON.stringify(this.shiftForm.value))
    }

    this.listAvailability((employee: EmployeeAvailable) => {
      this.authService.isSignedIn().subscribe(result => {
        this.isLoggedIn = result.signed_in

        if (this.isLoggedIn) {
          this.customerService.current().subscribe(user => {
            this.currentUser = user

            this.shiftForm.controls.customer.setValue(this.currentUser.default_customer)
            this.setLocationName()
          })
        }

        this.settingsService.organizationPublic().subscribe(organization => {

          this.organization = organization
          this.minimumOrder = organization.minimum_order
        })
        
        this.employee = employee
        this.allProducts = employee.products
        this.assignments = employee.assignments
        
        // Filter assignments to only include those that have associated products
        /*
        this.assignments = this.localeSortPipe.transform(
          this.assignments.filter((assignment) =>
            this.allProducts.find(product =>
              product.assignment_mappings.find(mapping =>
                assignment.id == mapping.assignment_id))
          ),
          'name'
        )
        */

        this.route.queryParams.subscribe(params => {
          console.log(params)
          if (params['services']) {
            this.settingsService.assignmentPublicBySlug(params['services']).subscribe(assignments => {
              if(assignments.length > 0)
                this.shiftForm.controls.assignment_id.setValue(assignments[0].id)
              else
                this.shiftForm.controls.assignment_id.setValue(this.assignments[0].id)
              
              this.selectAssignment()
            })
          }

          else {
            if (this.assignments.length > 0) {
              this.shiftForm.controls.assignment_id.setValue(this.assignments[0].id)
              this.selectAssignment()
            }
          }
        })
      })
    })


    localStorage.setItem('order', JSON.stringify(this.shiftForm.value))
  }

  productRequestSend() {
    if (this.productRequest.nativeElement.value == '')
      return

    this.settingsService.productRequestCreate(this.productRequest.nativeElement.value).subscribe(() => {
      alert($localize`Request sent. Thank you.`)
      this.productRequest.nativeElement.value = ''
    })
  }

  feedback(employee: Employee) {
    const modal = this.modalService.open(FeedbackComponent, { centered: true, size: 'lg', scrollable: true })

    modal.componentInstance.employee = employee
  }

  order() {
    this.router.navigate(['/checkout'])
  }

  selectEmployee(employee_id: number, start_time: MouseEvent) {
    const selectElement = ((start_time.target as HTMLElement).previousElementSibling) as HTMLSelectElement;
    const selectedValue = selectElement.value;

    //this.shiftForm.controls.employee_id.setValue(employee_id)
    
    //this.shiftForm.controls.start_times.setValue(selectedValue)

    this.cdRef.detectChanges()

    localStorage.setItem('order', JSON.stringify(this.shiftForm.value))

    this.router.navigate(['/checkout'])
  }

  listAvailability(callBack?: (employee: EmployeeAvailable) => void) {
    let order = JSON.parse(localStorage.getItem('order')!)

    this.route.params.subscribe(params => {
      if (params['referralCode']) {
        this.loading = true

        this.employeeService.partner(params['referralCode'], order).subscribe({
          next: (employee) => {

            this.titleService.setTitle($localize`Partner` + ' ' + employee.first_name)

            localStorage.setItem('api_url', employee.api_url)
            localStorage.setItem('ws_url', employee.ws_url)
            localStorage.setItem('organization', `${employee.organization_id}`)
            localStorage.setItem('city', `${employee.city_id}`)
            localStorage.setItem('country_code', `${employee.country_code}`)
            localStorage.removeItem('order')

            this.locationService.updateApiURL()

            this.shiftForm.controls.employee_id.setValue(employee.id)

            localStorage.setItem('order', JSON.stringify(this.shiftForm.value))

            this.loading = false

            if (callBack) {
              callBack(employee)
            }
          },
          error: (e) => { 
            
           }})
      }
    })
  }

  selectAssignment() {
    this.products = this.allProducts.filter(product => { return product.assignment_mappings.find(mapping => { return mapping.assignment_id == this.shiftForm.controls.assignment_id.value }) })

    this.selectedAssignment = this.assignments.find(assignment => assignment.id == this.shiftForm.controls.assignment_id.value)
  }

  updateOrderProducts() {
    this.orderProducts = []
    if (!this.shiftForm.controls.products.value) {
      return
    }

    for (let product of this.shiftForm.controls.products.value) {
      let productObject = this.products.find(p => p.id == product.product_id)

      this.orderProducts.push({ ...product, product: productObject })
    }

    localStorage.setItem('order', JSON.stringify(this.shiftForm.value))
  }

  deleteProduct(index: number) {
    if (!confirm($localize`Are you sure you want to delete this item?`)) {
      return
    }
    this.shiftForm.controls.products.value.splice(index, 1)
    this.updateOrderProducts()
  }

  editProduct(index: number) {
    const modal = this.modalService.open(ProductComponent, { centered: true, fullscreen: 'lg' })

    modal.componentInstance.assignment = this.selectedAssignment
    modal.componentInstance.product = this.products.find(p => p.id === this.orderProducts[index].product.id)
    modal.componentInstance.values = this.orderProducts[index]

    modal.result.then((result) => {
      if (result) {
        if (!this.shiftForm.controls.products.value) {
          this.shiftForm.controls.products.setValue([])
        }

        if (result.number < 1) {
          this.shiftForm.controls.products.value.splice(index, 1)
        }

        else {
          this.shiftForm.controls.products.value[index] = result
        }

        this.updateOrderProducts()

      }
    })
  }

  orderProduct(product: Product | undefined, values: any) {
    const modal = this.modalService.open(ProductComponent, { centered: true, fullscreen: 'lg' })

    modal.componentInstance.assignment = this.selectedAssignment
    modal.componentInstance.product = product
    modal.componentInstance.values = values

    modal.result.then((result) => {
      if (result) {
        if (!this.shiftForm.controls.products.value) {
          this.shiftForm.controls.products.setValue([])
        }

        this.shiftForm.controls.products.value.push(result)
        this.updateOrderProducts()
      }
    })
  }

  setDate(_event: any) {
    this.shiftForm.controls.start_times.setValue(null)

    localStorage.setItem('order', JSON.stringify(this.shiftForm.value))

    const ctrl = this.shiftForm.controls

    if (ctrl.customer.value && ctrl.customer.value.area_id && ctrl.date.value) {
      this.listAvailability()
    }
  }

  setLocationName() {
    const customer = this.shiftForm.controls.customer.value

    if (customer) {
      this.locationName = `${customer.street_address}`

      if (customer.office)
        this.locationName += `, ${customer.office}`

      this.locationName += `, ${customer.city}`
    }

    else {
      this.locationName = $localize`Set location`
    }
  }

  setLocation() {
    const modal = this.modalService.open(LocationComponent, { centered: true, size: 'md' })

    modal.result.then((customer) => {
      if (customer) {
        this.shiftForm.controls.customer.setValue(customer)

        this.setLocationName()
      }

      else {
        //this.shiftForm.controls.area_id.setValue(null)
        //this.shiftForm.controls.customer.setValue(null)

        //this.setLocationName()
      }

      localStorage.setItem('order', JSON.stringify(this.shiftForm.value))

      const ctrl = this.shiftForm.controls

      if (ctrl.customer.value && ctrl.customer.value.area_id && ctrl.date.value) {
        this.listAvailability()
      }
    })
  }

  validStartDate = (date: NgbDateStruct, current?: { year: number; month: number; }): boolean => {
    const d = new Date(Date.UTC(date.year, date.month - 1, date.day, 0, 0, 0, 0));
    const dateStr = d.toISOString().split('T')[0]

    if ((d.getDay() == 1 && !this.organization.customer_order_monday)
      || (d.getDay() == 2 && !this.organization.customer_order_tuesday)
      || (d.getDay() == 3 && !this.organization.customer_order_wednesday)
      || (d.getDay() == 4 && !this.organization.customer_order_thursday)
      || (d.getDay() == 5 && !this.organization.customer_order_friday)
      || (d.getDay() == 6 && !this.organization.customer_order_saturday)
      || (d.getDay() == 0 && !this.organization.customer_order_sunday)
    ) {
      return true
    }

    if (this.holidays.filter(holiday => holiday.date == dateStr).length > 0) {
      return true
    }

    return false
  }

  languageSelector() {
    const modal = this.modalService.open(LanguageSelectorComponent, { centered: true, size: 'md' })
  }

  tnc() {
    if (!this.selectedOrganization) {
      alert($localize`Select a country first.`)
      return
    }

    const modal = this.modalService.open(TncComponent, { centered: true, size: 'lg' })

    modal.componentInstance.organization = this.selectedOrganization
    modal.componentInstance.showAccept = false
  }

  privacyPolicy() {
    const modal = this.modalService.open(PrivacyPolicyComponent, { centered: true, size: 'lg' })
  }

  languageFlag(lang: string) {
    if (lang == 'ar') {
      return '🇪🇬'
    } else if (lang == 'bg') {
      return '🇧🇬'
    } else if (lang == 'bn') {
      return '🇧🇩'
    } else if (lang == 'bs') {
      return '🇧🇦'
    } else if (lang == 'cs') {
      return '🇨🇿'
    } else if (lang == 'da') {
      return '🇩🇰'
    } else if (lang == 'de') {
      return '🇩🇪'
    } else if (lang == 'el') {
      return '🇬🇷'
    } else if (lang == 'en') {
      return '🇬🇧'
    } else if (lang == 'es') {
      return '🇪🇸'
    } else if (lang == 'et') {
      return '🇪🇪'
    } else if (lang == 'fi') {
      return '🇫🇮'
    } else if (lang == 'fr') {
      return '🇫🇷'
    } else if (lang == 'ga') {
      return '🇮🇪'
    } else if (lang == 'ha') {
      return '🇳🇬'
    } else if (lang == 'he') {
      return '🇮🇱'
    } else if (lang == 'hi') {
      return '🇮🇳'
    } else if (lang == 'hr') {
      return '🇭🇷'
    } else if (lang == 'hu') {
      return '🇭🇺'
    } else if (lang == 'hy') {
      return '🇦🇲'
    } else if (lang == 'id') {
      return '🇮🇩'
    } else if (lang == 'it') {
      return '🇮🇹'
    } else if (lang == 'ja') {
      return '🇯🇵'
    } else if (lang == 'ka') {
      return '🇬🇪'
    } else if (lang == 'ko') {
      return '🇰🇷'
    } else if (lang == 'lb') {
      return '🇱🇺'
    } else if (lang == 'lt') {
      return '🇱🇹'
    } else if (lang == 'lv') {
      return '🇱🇻'
    } else if (lang == 'mk') {
      return '🇲🇰'
    } else if (lang == 'mt') {
      return '🇲🇹'
    } else if (lang == 'nl') {
      return '🇳🇱'
    } else if (lang == 'no') {
      return '🇳🇴'
    } else if (lang == 'pl') {
      return '🇵🇱'
    } else if (lang == 'pt') {
      return '🇵🇹'
    } else if (lang == 'ro') {
      return '🇷🇴'
    } else if (lang == 'ru') {
      return '🇷🇺'
    } else if (lang == 'sk') {
      return '🇸🇰'
    } else if (lang == 'sl') {
      return '🇸🇮'
    } else if (lang == 'sq') {
      return '🇦🇱'
    } else if (lang == 'sr') {
      return '🇷🇸'
    } else if (lang == 'sv') {
      return '🇸🇪'
    } else if (lang == 'sw') {
      return '🇰🇪'
    } else if (lang == 'th') {
      return '🇹🇭'
    } else if (lang == 'tl') {
      return '🇵🇭'
    } else if (lang == 'tr') {
      return '🇹🇷'
    } else if (lang == 'uk') {
      return '🇺🇦'
    } else if (lang == 'vi') {
      return '🇻🇳'
    } else if (lang == 'xh') {
      return '🇿🇦'
    } else if (lang == 'yo') {
      return '🇳🇬'
    } else if (lang == 'zh') {
      return '🇨🇳'
    } else if (lang == 'zu') {
      return '🇿🇦'
    } else {
      return '🇺🇳'
    }
  }
}
